import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { useCms } from "../context/CmsContext";

export default function Footer() {
    const cms = useCms();
    const t = (k, fb) => cms.get(k, fb);
    return (
        <footer data-testid="public-footer" className="border-t border-white/10 bg-ink-800">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-[42px] grid grid-cols-1 md:grid-cols-3 gap-12">
                <div>
                    <Logo variant="mark" className="h-36 w-auto" />
                    <p className="mt-6 text-base text-white/70 max-w-xs leading-relaxed whitespace-pre-line">
                        {t("footer.tagline", "Nos accompagnements à chaque étape de votre parcours.")}
                    </p>
                </div>

                <div>
                    <span className="font-serif text-xl text-ice block mb-4">Contact</span>
                    <div className="space-y-3 text-base text-white/85">
                        <div className="flex items-start gap-3">
                            <Mail size={16} className="text-ice mt-1 shrink-0" />
                            <Link to="/contact" data-testid="footer-contact-link" className="hover:text-ice transition-colors">
                                Formulaire de contact
                            </Link>
                        </div>
                        <div className="flex items-start gap-3">
                            <MapPin size={16} className="text-ice mt-1 shrink-0" />
                            <div>
                                <div>{t("footer.city1", "Paris, France")}</div>
                                <div>{t("footer.city2", "Bordeaux, France")}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:text-right space-y-3">
                    <Link
                        to="/contact"
                        data-testid="footer-cta-rdv"
                        className="inline-block bg-ice text-white hover:bg-ice-soft hover:text-ink-900 transition-colors px-7 py-3.5 rounded-md font-medium tracking-wide"
                    >
                        Prendre rendez-vous
                    </Link>
                    <div className="mt-4 text-sm">
                        <Link
                            to="/login"
                            data-testid="footer-portal-link"
                            className="text-white/60 hover:text-ice transition-colors"
                        >
                            Connexion
                        </Link>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 text-sm text-white/40 flex flex-wrap justify-between gap-2">
                    <span>© {new Date().getFullYear()} Vecteurs Conseil. Tous droits réservés.</span>
                    <span>Orientation scolaire & professionnelle</span>
                </div>
            </div>
        </footer>
    );
}
